import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const itemCodeApi = tokenSlice.injectEndpoints({
    reducerPath: "itemCode",
    baseQuery: createBaseQuery(),
    endpoints(builder) {
        return {
            getItemCode: builder.query({
                query: (businessUnitId) => {
                    return {
                        url: `Item/GetItemCodes/${businessUnitId}`,
                        method: "GET"
                    };
                }
            })
        };
    }
});

export const { useGetItemCodeQuery } = itemCodeApi
export { itemCodeApi };